/*
  BMS product lightbox zoom (17 Sep 2026).
  Clarity showed shoppers opening the photo lightbox, then clicking the photo
  and getting nothing back (dead clicks on every marquee PDP). Now a click or
  tap on a photo zooms it 2x around the point you touched, and a second click
  zooms back out. The background and the close button still close the lightbox
  (see ModalDialog in global.js).
*/
(function () {
  function unzoomAll(root) {
    root.querySelectorAll('img.bms-zoomed').forEach(function (img) {
      img.classList.remove('bms-zoomed');
      img.style.removeProperty('--bms-zoom-w');
    });
  }

  document.addEventListener('click', function (event) {
    var img = event.target.closest('.product-media-modal__content img');
    if (!img) return;
    var scroller = img.closest('.product-media-modal__content');
    if (!scroller) return;

    if (img.classList.contains('bms-zoomed')) {
      unzoomAll(scroller);
      img.scrollIntoView({ block: 'center', behavior: 'instant' });
      return;
    }

    unzoomAll(scroller);
    var before = img.getBoundingClientRect();
    var fx = (event.clientX - before.left) / before.width;
    var fy = (event.clientY - before.top) / before.height;

    img.classList.add('bms-zoomed');
    img.style.setProperty('--bms-zoom-w', Math.round(before.width * 2) + 'px');

    var after = img.getBoundingClientRect();
    scroller.scrollLeft += after.left + fx * after.width - event.clientX;
    scroller.scrollTop += after.top + fy * after.height - event.clientY;
  });

  document.body.addEventListener('modalClosed', function () {
    unzoomAll(document);
  });
})();
